import { ImgKey } from '../media'
import { OssConfig } from '../../config'

export class Todo extends ImgKey {

  todo_id: number
  content: string
  done: boolean
  date: string
  posted_by: string

  constructor(data: any = {}) {
    super(OssConfig.todo, data.img_key)
    this.todo_id = data.todo_id
    this.content = data.content
    this.done = Boolean(data.done)
    this.date = data.date || new Date().toISOString().slice(0, 10)
    this.posted_by = data.posted_by
  }

  get status(): string {
    return this.done ? '完成' : '待办'
  }

  get editLink(): string {
    return `/operation/todo/edit/${this.todo_id}`
  }

  public toggleStatus() {
    this.done = !this.done
  }

}



// WEBPACK FOOTER //
// ./src/app/models/operation/todo.ts